/* eslint-disable no-shadow */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { styled as muiStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import { DatePicker } from '@mui/x-date-pickers';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import {
  Delete, Clear, CloudUpload,
} from '@mui/icons-material';
import { components } from 'react-select';
import MomentTz from 'moment-timezone';
import { matchSorter } from 'match-sorter';
import _ from 'lodash';
import { VAULT_MEDIA_TYPE } from '../../../../constants/vault';
import { selectIsUserVaultSuperAdmin } from '../../../../state/user/userOrgRole';
import { parseAbbreviatedDateString, parseAbbreviatedStringFromDate } from '../../../../utils/time';
import {
  StyledFormControl, DropdownOptionContainer, StyledSelect,
  InputContainer, AttachmentsContainer, Spacer, DropContainer,
} from './styles';
import VaultButton from '../../VaultButton';

const MaterialTextField = muiStyles(TextField)({
  '& textarea, .MuiInput-input, .Mui-disabled': {
    color: [['black'], '!important'],
    fontSize: [['12px'], '!important'],
    lineHeight: [[2], '!important'],
  },
});

const MaterialDatePicker = muiStyles(DatePicker)({
  '& input, .MuiInputBase-input .Mui-disabled': {
    color: [['black'], '!important'],
    fontSize: [['12px'], '!important'],
    lineHeight: [[2], '!important'],
  },
});

const defaultDropdownOption = {
  Option: (props) => (
    <DropdownOptionContainer>
      <components.Option {...props} />
    </DropdownOptionContainer>
  ),
};

const formattedDateTags = ['createdDate', 'modifiedDate'];

const addEmptyOption = (options) => {
  const emptyOptionIndex = options.findIndex((val) => val.value === '');
  if (emptyOptionIndex !== -1 && emptyOptionIndex !== 0) {
    const emptyOption = options.splice(emptyOptionIndex, 1);
    options.unshift(emptyOption[0]);
  } else if (emptyOptionIndex === -1) {
    options.unshift({ value: '', label: 'N/A' });
  }
  return options;
};

class AssetField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: [],
    };
  }

  componentDidMount() {
    const { lookupOptions, tagName } = this.props;
    let options = [];
    if (tagName === 'photoRotation') options = lookupOptions;
    else options = _.sortBy(lookupOptions, (option) => option.value.toLowerCase());
    this.setState({ options: addEmptyOption(options) });
  }

  componentDidUpdate(prevProps) {
    const { lookupOptions } = this.props;
    if (prevProps.lookupOptions.length !== lookupOptions.length) {
      this.setState({ options: addEmptyOption(_.sortBy(lookupOptions, (option) => option.value.toLowerCase())) });
    }
  }

  renderAttachments = () => {
    const {
      labelValue, label, value, disabled, onHandleDropAttachments, onHandleDeleteAttachment,
    } = this.props;
    const exchangeFile = value.find((attachment) => attachment.attachmentType === 'xchange');
    const filteredAttachments = value.filter((attachment) => attachment.attachmentType !== 'xchange'); // Hide xchange file for lacrosse
    if (!filteredAttachments.length && disabled) return <></>;
    return (
      <StyledFormControl>
        <InputLabel id={`AssetDetails.AssetInfo.Metadata.${labelValue}`} shrink>
          {label}
        </InputLabel>
        <InputContainer>
          {!disabled && (
            <DropContainer key={labelValue}>
              <Dropzone onDrop={(files) => onHandleDropAttachments(files, exchangeFile)}>
                {({ getRootProps, getInputProps }) => (
                  <section key={labelValue}>
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <VaultButton
                        variant="primaryOnWhite"
                        data-auto="ExchangeUploadBtn"
                      >
                        <CloudUpload
                          data-tip="Upload to Exchange"
                          data-for="results-actions-tooltip"
                        />
                      </VaultButton>
                      <span>Drag and drop files here, or click to select files.</span>
                    </div>
                  </section>
                )}
              </Dropzone>
            </DropContainer>
          )}
          <AttachmentsContainer className={disabled ? 'disabled' : ''}>
            {filteredAttachments.map((attachment) => (
              <div key={attachment.sourceFileName} className="attachment">
                <div className="attachment-name">
                  <span className="label">{attachment.sourceFileName}</span>
                  {attachment.newFile && (<Chip label="Updating" size="small" />)}
                </div>
                {!disabled && (
                  <div className="buttons">
                    {/* Don't allow users to delete the xchange file */}
                    {attachment.attachmentType !== 'xchange' ? (
                      <IconButton
                        onClick={(event) => {
                          event.stopPropagation();
                          onHandleDeleteAttachment(attachment);
                        }}
                        size="small"
                      >
                        <Clear disabled={false} fontSize="inherit" />
                      </IconButton>
                    ) : <Spacer />}
                  </div>
                )}
              </div>
            ))}
          </AttachmentsContainer>
        </InputContainer>
      </StyledFormControl>
    );
  };

  renderDatePicker = () => {
    const {
      assetType, onDateChange, label, labelValue, value, disabled,
    } = this.props;
    const date = value || null;
    return (
      <StyledFormControl>
        <InputLabel id={`AssetDetails.AssetInfo.Metadata.${labelValue}`} shrink>
          {label}
        </InputLabel>
        <InputContainer>
          <MaterialDatePicker
            id={`AssetDetails.AssetInfo.Metadata.${labelValue}.Value`}
            value={parseAbbreviatedDateString(date)}
            margin="normal"
            format="MM-dd-yyyy"
            disableFuture={assetType !== VAULT_MEDIA_TYPE.liveVideo}
            clearable
            autoOk
            onChange={(value) => onDateChange(parseAbbreviatedStringFromDate(value))}
            disabled={disabled}
            variant="inline"
            disableToolbar
            slotProps={{
              actionBar: {
                actions: ['clear', 'today'],
              },
            }}
          />
        </InputContainer>
      </StyledFormControl>
    );
  };

  renderOwner = () => {
    const {
      productOptions, labelValue, label, value, disabled, onChange,
    } = this.props;
    const orgOptions = productOptions[1];
    const availableOptions = [...orgOptions.options];
    const selectedOption = availableOptions.find((spo) => spo.value === value);
    return (
      <StyledFormControl>
        <InputLabel id={`AssetDetails.AssetInfo.Metadata.${labelValue}`} shrink>
          {label}
        </InputLabel>
        <InputContainer>
          <StyledSelect
            value={selectedOption}
            options={[orgOptions]}
            onChange={(e) => onChange({ target: { value: e.label } })}
            isDisabled={disabled}
            components={{ ...defaultDropdownOption }}
          />
        </InputContainer>
      </StyledFormControl>
    );
  };

  renderLookup = () => {
    const { options } = this.state;
    const {
      isVaultSuperAdmin, lookupOptions, onDeleteOption,
      allowAddRemove, label, labelValue, disabled, onChange,
    } = this.props;
    let { value } = this.props;
    if (typeof value === 'boolean') value = value.toString();
    return (
      <StyledFormControl>
        <InputLabel id={`AssetDetails.AssetInfo.Metadata.${labelValue}`} shrink>
          {label}
        </InputLabel>
        <InputContainer>
          <StyledSelect
            value={{ value, label: value }}
            data-value={value}
            options={options}
            components={{
              Option: (props) => (
                <DropdownOptionContainer>
                  <components.Option {...props}>
                    <div>{props.children}</div>
                    {(props.value && props.value !== '' && !props.data.newValue && allowAddRemove) && (
                      <div className="buttons">
                        <IconButton
                          onClick={(event) => {
                            event.stopPropagation();
                            onDeleteOption(props.value);
                          }}
                          size="small"
                        >
                          <Delete disabled={false} fontSize="inherit" />
                        </IconButton>
                      </div>
                    )}
                  </components.Option>
                </DropdownOptionContainer>
              ),
            }}
            onInputChange={(inputValue) => {
              const optionValues = matchSorter(lookupOptions, inputValue, { keys: ['label'] });
              if (isVaultSuperAdmin && inputValue !== '' && inputValue !== 'N/A' && !optionValues.map((val) => val.value).includes(inputValue) && allowAddRemove) {
                optionValues.push({ value: `${inputValue}`, label: `Add '${inputValue}'`, newValue: true });
              }
              this.setState({ options: inputValue === '' ? addEmptyOption(optionValues) : optionValues });
            }}
            filterOption={(val, input) => {
              if (input) {
                if (val.value === '') return true;
                return val.value.toLowerCase().includes(input.toLowerCase());
              }
              return true;
            }}
            onChange={(e) => onChange({ target: { value: e.value } }, e.newValue)}
            isDisabled={disabled}
          />
        </InputContainer>
      </StyledFormControl>
    );
  };

  renderTextField = () => {
    const {
      onBlur, labelValue, label, onChange, disabled, tagName,
    } = this.props;
    let { value } = this.props;
    // TODO: if createdDate or modifiedDate ever becomes editable for some reason, this will need to be reworked
    value = formattedDateTags.includes(tagName) ? MomentTz.tz(value, MomentTz.tz.guess()).format('L LT') : value;
    return (
      <StyledFormControl>
        <InputLabel id={`AssetDetails.AssetInfo.Metadata.${labelValue}`} shrink>
          {label}
        </InputLabel>
        <InputContainer>
          <MaterialTextField
            id={`AssetDetails.AssetInfo.Metadata.${labelValue}.Value`}
            onChange={onChange}
            data-value={value}
            value={value}
            placeholder={`Please Enter ${label}`}
            margin="normal"
            multiline
            disabled={disabled}
            onBlur={onBlur}
          />
        </InputContainer>
      </StyledFormControl>
    );
  };

  renderSecurityProfiles = () => {
    const {
      tagName, label, disabled, onChange, productOptions, value, labelValue,
    } = this.props;
    const [{ options: groupOptions }, { options: orgOptions }] = productOptions;
    const availableOptions = [...groupOptions, ...orgOptions];
    const selectedOptions = value.map((val) => availableOptions.find((opt) => opt.label === val));
    return (
      <StyledFormControl>
        <InputLabel
          id={`AssetDetails.AssetInfo.Metadata.${labelValue}`}
          shrink
          htmlFor={`select-multiple-${tagName}`}
        >
          {label}
        </InputLabel>
        <InputContainer>
          <StyledSelect
            value={selectedOptions}
            options={productOptions}
            onChange={(e) => onChange({ target: { value: e.map((option) => option.label) } })}
            isDisabled={disabled}
            closeMenuOnSelect={false}
            isMulti
            components={{
              ClearIndicator: () => null, ...defaultDropdownOption,
            }} // Cannot clear security profiles
          />
        </InputContainer>
      </StyledFormControl>
    );
  };

  render() {
    const {
      dataType, tagName, lookupObjectId,
    } = this.props;

    if (tagName === 'attachments') return this.renderAttachments();
    if (dataType === 'date') return this.renderDatePicker();
    // Security profiles select
    if (tagName === 'securityProfiles') return this.renderSecurityProfiles();
    // Owner select
    if (tagName === 'owner') return this.renderOwner();

    // Single lookup select
    if (lookupObjectId) return this.renderLookup();

    // Default to text field
    return this.renderTextField();
  }
}

AssetField.defaultProps = {
  onChange: () => { },
  onDateChange: () => { },
};

AssetField.propTypes = {
  assetType: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  labelValue: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  dataType: PropTypes.string.isRequired,
  tagName: PropTypes.string.isRequired,
  lookupObjectId: PropTypes.string,
  lookupOptions: PropTypes.array.isRequired,
  allowAddRemove: PropTypes.bool.isRequired,
  spOptions: PropTypes.array.isRequired, // supplied from Redux
  productOptions: PropTypes.array.isRequired, // supplied from Redux
  onChange: PropTypes.func,
  onDateChange: PropTypes.func,
  onBlur: PropTypes.func,
  onDeleteOption: PropTypes.func,
  isVaultSuperAdmin: PropTypes.bool.isRequired,
  onHandleDropAttachments: PropTypes.func,
  onHandleDeleteAttachment: PropTypes.func,
};

const mapStateToProps = (state) => ({
  // note: for react-select
  isVaultSuperAdmin: selectIsUserVaultSuperAdmin(state),
  spOptions: state.securityProfiles?.options ?? [],
  productOptions: state.securityProfiles?.productOptions ?? [],
});

export default connect(mapStateToProps)(AssetField);
